export class PopupChecker {
  constructor({
    url = "",
    name = "",
    postMessage,
    recieveMessage = postMessage
  }) {
    this.postMessage = postMessage;
    this.recieveMessage = recieveMessage;
    this.name = name;

    this.popup = window.open(
      url,
      name,
      "top=100,left=100,width=900,height=600"
    );
  }

  changeUrl(url) {
    this.popup.location.href = url;
  }

  observe() {
    const { popup, postMessage, recieveMessage } = this;

    return new Promise(resolve => {
      window.addEventListener("message", onMessage);

      const popupChecker = setInterval(() => {
        if (popup.closed) {
          clear();
          resolve({
            closed: true,
            success: false
          });
        }
        popup.postMessage(postMessage, "*");
      }, 1000);

      function onMessage(e) {
        if (e.data.type === recieveMessage) {
          clear();
          popup.close();
          resolve(e.data);
        }
      }

      function clear() {
        clearTimeout(popupChecker);
        window.removeEventListener("message", onMessage);
      }
    });
  }
}
